import useTranslation from 'hooks/useTranslation';

import style from './index.style';
import useResponsive from '../../../../hooks/useResponsive';
import { useRouterWithLang } from 'hooks/useRouterWithLang';

export default function BannerShipping({}) {
  const { TRANSLATIONS } = useTranslation();
  const { isMobile } = useResponsive();
  const router = useRouterWithLang();
  const query = router.query;

  return (
    <div className="banner-shipping-wrapper jc-sb">
      <div className={`banner-shipping d-f g-10 fw-w jc-sb flex-d`}>
        <div
          className={`banner-shipping-info d-f ai-c g-5 f-1 ${
            !isMobile && 'fd-c'
          }`}
        >
          <div className="icon-bg">
            <img src="/images/home/stepFree/01-icon.svg" alt="01-icon" />
          </div>
          <p className={'ta-c'}>{TRANSLATIONS.products.list.header.title_1}</p>
        </div>
        <div
          className={`banner-shipping-info d-f ai-c g-5 f-1 ${
            !isMobile && 'fd-c'
          }`}
        >
          <div className="icon-bg">
            <img src="/images/home/stepFree/02-icon.svg" alt="02-icon" />
          </div>
          <p className={'ta-c'}>{TRANSLATIONS.products.list.header.title_2}</p>
        </div>
        <div
          className={`banner-shipping-info d-f ai-c g-5 f-1 ${
            !isMobile && 'fd-c'
          }`}
        >
          <div className="icon-bg">
            <img src="/images/home/stepFree/03-icon.svg" alt="03-icon" />
          </div>
          <p className={'ta-c'}>{TRANSLATIONS.products.list.header.title_3}</p>
        </div>
      </div>
      <style jsx>{style}</style>
    </div>
  );
}
